import ReactPlayer from 'react-player/lazy';
import { ReactElement, useEffect, useState } from 'react';
import styles from './Player.module.scss';
import classNames from 'classnames';

export interface UI_PlayerProps {
	url: string;
	isLight?: boolean;
	poster?: string;
	playing?: boolean;
	loop?: boolean;
	controls?: boolean;
	cover?: boolean;
	muted?: boolean;
	playIcon?: ReactElement;
	preload?: 'none' | 'metadata' | 'auto';
}

export const UI_Player = ({
	preload,
	url,
	muted = false,
	isLight = true,
	poster,
	playing = false,
	loop = false,
	controls = true,
	cover,
	playIcon,
}: UI_PlayerProps) => {
	const light = !isLight ? false : poster ? poster : true;
	const className = classNames(styles.Player, { [styles['Player--cover']]: cover });

	/**
	 * react-player swaps its Suspense boundary for `() => null` when there is no window
	 * (UniversalSuspense in react-player/lib/ReactPlayer.js), so the server emits an empty
	 * wrapper while the client fills it with the preview or the player. Holding back the
	 * player until after mount keeps the first client render identical to the server output,
	 * which is what hydration compares. The placeholder keeps the aspect ratio box reserved
	 * so nothing shifts when the player takes over.
	 */
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted) {
		return <div className={className} style={{ width: '100%', height: '100%' }} aria-hidden="true" />;
	}

	return (
		<ReactPlayer
			url={url}
			className={className}
			light={light}
			muted={muted}
			playing={playing}
			loop={loop}
			controls={controls}
			width="100%"
			height="100%"
			playsinline={true}
			playIcon={playIcon}
			config={{
				youtube: {
					playerVars: { modestbranding: 1 },
				},
				file: {
					attributes: {
						preload,
					},
				},
			}}
		/>
	);
};
